import { CSSProperties } from 'react';
import { Combobox } from '@mantine/core';
import clsx from 'clsx';

import { Checkbox } from '../checkbox/Checkbox';
import { TextWithTooltip } from '../tooltip/TextWithTooltip';

import styles from './select-option.module.scss';

type SelectOptionProps = {
  active: boolean;
  checkbox?: boolean;
  label: string;
  onClick?: () => void;
  selected?: boolean;
  style?: CSSProperties;
  value: string;
  variant?: 'primary' | 'secondary';
};

export function SelectOption({
  active,
  checkbox = false,
  label,
  onClick,
  selected,
  style,
  value,
  variant,
}: SelectOptionProps) {
  return (
    <Combobox.Option
      role="option"
      value={value}
      active={active}
      selected={selected}
      onClick={onClick}
      className={clsx(
        styles['option'],
        variant === 'primary' && styles['option--primary']
      )}
      style={style}
    >
      {checkbox && <Checkbox checked={active} />}
      <TextWithTooltip
        tooltipProps={{
          position: 'right',
          usePortal: true,
        }}
        textProps={{ lineClamp: 1 }}
      >
        {label}
      </TextWithTooltip>
    </Combobox.Option>
  );
}
